import React, { useState } from "react";
import { Col, Nav, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const HelpInstall = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("ios");

  return (
    <>
      <div className="text-center mt-5">
        <h2>{t("auto.instalarAApp", "Instalar a app")}</h2>
      </div>
      <div className="mx-lg-5 text-justified">
        <p>
          {t(
            "auto.deFormaATerUmAcessoImediatoAAplicacaoPoderaAdicionarAMesmaAoEcraDeEntradaNoSeuTelemoveltabletTalComoUmaAplicacaoDescarregadaDasAppStores",
            "De forma a ter um acesso imediato à aplicação, poderá adicionar a mesma ao ecrã de entrada no seu\n          telemóvel/tablet, tal como uma aplicação descarregada das AppStores.",
          )}
          <br />
          {t(
            "auto.sigaAsInstrucoesAbaixoConsoanteOSeuDispositivo",
            "Siga as instruções abaixo, consoante o seu dispositivo.",
          )}
        </p>

        <div>
          <Nav
            variant="tabs"
            defaultActiveKey={selectedTab}
            onSelect={setSelectedTab}
          >
            <Nav.Item>
              <Nav.Link eventKey="android">
                {t("auto.androidChrome", "Android / Chrome")}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="ios">
                {t("auto.iphoneIPad", "iPhone / iPad")}
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <div className="tabs-container">
            <Row>
              <Col xs="12" md="6" className="pt-4">
                {selectedTab === "android" && (
                  <div>
                    <ol>
                      <li>
                        {t(
                          "auto.noSeuDispositivoAndroidAbraOChrome",
                          "No seu dispositivo Android, abra o Chrome",
                        )}{" "}
                        <img
                          src={require("img/icons/chrome.png")}
                          width="18"
                          height="18"
                          alt="Chrome"
                          className="mx-2"
                        />
                        .
                      </li>
                      <li>
                        {t("auto.toqueEm", "Toque em")}{" "}
                        <strong>{t("auto.instalar", "Instalar")}</strong>.
                      </li>
                      <li>
                        {t(
                          "auto.seAOpcaoParaInstalarNaoLheAparecerToqueEm",
                          "Se a opção para instalar não lhe aparecer, toque em",
                        )}{" "}
                        <i className="bi bi-three-dots-vertical"></i>
                        {t(
                          "auto.paraAcederAoMenuEDepoisEm",
                          "para aceder ao menu, e depois em",
                        )}{" "}
                        <strong>
                          {t("auto.instalarAplicacao", "Instalar aplicação")}
                        </strong>
                      </li>
                      <li>
                        {t(
                          "auto.sigaAsInstrucoesNoEcra",
                          "Siga as instruções no ecrã.",
                        )}
                      </li>
                      <li>
                        {t(
                          "auto.abraAAppICyclinAtravesDoSeuIcone",
                          "Abra a app iCyclin através do seu ícone:",
                        )}
                        <br />
                        <img
                          className="text-center mt-2 ms-5"
                          src="/logo192.png"
                          width="60"
                          height="auto"
                          alt="iCyclin app logo"
                        />
                      </li>
                    </ol>
                  </div>
                )}
                {selectedTab === "ios" && (
                  <div>
                    <ol>
                      <li>
                        {t(
                          "auto.noSeuIPhoneiPadAbraOSafari",
                          "No seu iPhone/iPad, abra o Safari",
                        )}
                        <img
                          src={require("img/icons/safari.png")}
                          width="18"
                          height="18"
                          alt="Safari"
                          className="mx-2"
                        />
                        .
                      </li>
                      <li>
                        {t("auto.toqueEm", "Toque em")}{" "}
                        <strong>{t("auto.partilhar", "Partilhar")}</strong>
                        <img
                          src={require("img/icons/share-icon-iphone-20.png")}
                          height="18"
                          alt="Partilhar"
                          className="mx-2"
                        />
                        .
                      </li>
                      <li>
                        {t(
                          "auto.facaScrollNaJanelaDePartilhaProcureEToqueNaOpcao",
                          "Faça scroll na janela de partilha, procure e toque na opção",
                        )}{" "}
                        <strong>
                          {t(
                            "auto.adicionarAoEcraPrincipal",
                            "Adicionar ao ecrã principal",
                          )}
                        </strong>{" "}
                        <i className="bi bi-plus-square-fill text-muted"></i>
                      </li>
                      <li>
                        {t(
                          "auto.confirmeOuEditeOsDetalhesDoWebsiteEToqueEm",
                          "Confirme ou edite os detalhes do Website e toque em",
                        )}{" "}
                        <strong>{t("auto.adicionar", "Adicionar")}</strong>.
                      </li>

                      <li>
                        {t(
                          "auto.abraAAppICyclinAtravesDoSeuIcone",
                          "Abra a app iCyclin através do seu ícone:",
                        )}
                        <br />
                        <img
                          className="text-center mt-2 ms-5"
                          src="/logo192.png"
                          width="60"
                          height="auto"
                          alt="iCyclin app logo"
                        />
                      </li>
                    </ol>
                  </div>
                )}
              </Col>
              <Col xs="12" md="6" className="d-flex justify-content-center">
                <div style={{ width: "100%", maxWidth: "300px" }}>
                  <div
                    style={{
                      padding:
                        (selectedTab === "android" ? "222.22" : "216.22") +
                        "% 0 0 0",
                      position: "relative",
                    }}
                  >
                    <iframe
                      src={
                        "https://player.vimeo.com/video/" +
                        (selectedTab === "android"
                          ? "921121388"
                          : "921168112") +
                        "?badge=0&player_id=0&app_id=58479&autoplay=1&loop=1&autopause=0&background=1&muted=1"
                      }
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%",
                        borderRadius: "10px",
                        boxShadow: "0px 0px 20px rgba(0,0,0,0.3)",
                      }}
                      title={t("auto.instalarAAppICyclin")}
                    ></iframe>
                  </div>
                  <script src="https://player.vimeo.com/api/player.js"></script>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpInstall;
